import { c as _c } from "react/compiler-runtime";
import type { SVGProps } from 'react';
export const IconMarketplace = t0 => {
  const $ = _c(10);
  let height;
  let props;
  let size;
  let width;
  if ($[0] !== t0) {
    ({
      size,
      width,
      height,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = height;
    $[2] = props;
    $[3] = size;
    $[4] = width;
  } else {
    height = $[1];
    props = $[2];
    size = $[3];
    width = $[4];
  }
  const t1 = size ?? width ?? 24;
  const t2 = size ?? height ?? 24;
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <path fill="currentColor" fillRule="evenodd" d="M38.484 1.93c-3.606.343-6.818 2.919-8.008 6.422-.415 1.224-.521 2.206-.523 4.848l-.001 1.776h-5.32l.022-2.32.022-2.32.18-.544c.294-.893.998-2.055 1.439-2.375.298-.217 1.075-.866 1.178-.983.37-.422.545-1.11.43-1.685a1.99 1.99 0 0 0-2.104-1.599c-.498.036-.804.177-1.476.683-1.663 1.25-2.932 3.194-3.45 5.287-.22.89-.265 1.532-.265 3.719v2.13l-4.368.022c-4.283.022-4.378.025-4.88.165-1.998.555-3.556 2.059-4.093 3.948-.125.441-.711 4.768-2.507 18.496-2.553 19.517-2.5 19.04-2.238 20.063.563 2.198 2.094 3.741 4.294 4.327.433.115 1.286.12 24.768.14 17.963.015 24.477.002 24.922-.053 2.903-.352 5.062-2.768 5.062-5.665 0-.44-.665-5.724-2.336-18.546-1.285-9.862-2.381-18.138-2.436-18.392a5.4 5.4 0 0 0-1.415-2.646c-.814-.851-1.732-1.4-2.79-1.668-.435-.11-.796-.139-2.075-.166l-1.547-.034-.026-2.504c-.022-2.074-.046-2.586-.137-2.984-.585-2.543-1.987-4.615-4.056-5.997a9.4 9.4 0 0 0-4.398-1.553c-.788-.074-1.024-.073-1.868.007m.086 4.02c-1.885.343-3.466 1.613-4.176 3.355-.422 1.036-.41.717-.41 10.479 0 8.501-.004 8.834-.121 9.142a2 2 0 0 1-3.296.728 2.5 2.5 0 0 1-.416-.598l-.167-.352-.019-4.848-.018-4.848h-4.453c-4.132 0-4.449.008-4.41.107.104.274.306 1.774 2.624 19.573 1.358 10.42 2.485 19.052 2.506 19.184l.037.24h14.927c16.647 0 15.244.04 15.803-.452.41-.36.579-.75.567-1.308-.006-.246-1.058-8.47-2.34-18.276-2.534-19.4-2.334-18.09-2.835-18.565-.477-.453-.541-.469-2.053-.491l-1.36-.021v4.825c0 5.47.026 5.175-.517 5.77-.419.458-.827.634-1.467.635-.782.001-1.416-.38-1.781-1.073l-.171-.324-.018-4.912-.017-4.912h-3.827c-4.24 0-4.218.002-4.759-.411-1.207-.922-.994-2.761.397-3.422l.352-.167 3.927-.019 3.926-.019-.029-2.22c-.027-2.022-.042-2.268-.168-2.734a5.56 5.56 0 0 0-3.88-3.944c-.508-.146-1.845-.215-2.358-.121M12.18 19.11c-.383.14-.81.541-.971.916-.112.26-.565 3.6-2.473 18.226C7.45 48.1 6.4 56.277 6.4 56.42c0 .607.415 1.248.992 1.533.25.124.43.127 7.535.144l7.278.017-.032-.177c-.018-.097-1.125-8.566-2.461-18.82s-2.46-18.756-2.496-18.893c-.099-.366-.43-.759-.832-.986l-.352-.198-1.792-.013c-1.46-.01-1.841.005-2.06.084" clipRule="evenodd" />;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== props || $[7] !== t1 || $[8] !== t2) {
    t4 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 64 64" width={t1} height={t2} {...props}>{t3}</svg>;
    $[6] = props;
    $[7] = t1;
    $[8] = t2;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  return t4;
};
IconMarketplace.displayName = 'IconMarketplace';